import MarkdownIt from "markdown-it";

// Renders an assistant answer as safe HTML for the Ask Savant drawer.
// Raw HTML is never parsed (html: false), images render as their alt text, and
// links survive only for http(s), same-app relative paths, and fragments, so
// javascript:, data:, and protocol-relative destinations render as plain text.
// The result is inserted with innerHTML by the ask-savant controller; user
// messages, thinking updates, and errors never come through here.

const md = new MarkdownIt({
  html: false,
  linkify: false,
  breaks: true,
  typographer: false
});

// Image syntax renders as its alt text. Disabling the rule instead would let
// `![alt](url)` degrade into "!" plus a link to the image, which is still a
// remote reference the answer never asked the reader to follow.
md.renderer.rules.image = (tokens, idx) => md.utils.escapeHtml(tokens[idx].content);

md.validateLink = (link) => {
  // Allow http://, https://
  if (/^https?:\/\//i.test(link)) return true;
  // Same-app relative paths starting with a single '/', not '//'
  if (link.startsWith("/") && !link.startsWith("//")) return true;
  // Allow # fragments
  if (link.startsWith("#")) return true;
  return false;
};

const defaultLinkOpen = md.renderer.rules.link_open || ((tokens, idx, options, env, self) => self.renderToken(tokens, idx, options));

md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  const href = tokens[idx].attrGet("href") || "";
  if (/^https?:\/\//i.test(href)) {
    tokens[idx].attrSet("target", "_blank");
    tokens[idx].attrSet("rel", "noopener noreferrer");
  }
  return defaultLinkOpen(tokens, idx, options, env, self);
};

export function renderAssistantMarkdown(text) {
  return md.render(String(text ?? ""));
}
